const targetingOptions = {
    TOPIC: 'topic',
    LOGO: 'logo',
};

export default targetingOptions;
